import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { YoutubeEmbedVideoComponent } from '../../../new-v2-component/youtube-embed-video/youtube-embed-video.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'sm-latest-purchases',
  templateUrl: './latest-purchases.component.html',
  styleUrls: ['./latest-purchases.component.scss']
})
export class LatestPurchasesComponent implements OnInit {
  repeatArray:any
  latestPurchaseData: any = {}
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  constructor(private _apiservice:ApiService, private router: Router,  private dialog:MatDialog) {
    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_LATEST_PURCHASES_FOR_DASHBOARD_COUNT){
        this.latestPurchaseData = {}
        if(resdata.result){
          this.latestPurchaseData = resdata.result
        }
       
        this.loader = false
      }
    })
   }

  ngOnInit(): void {
    this.loader = true
    this._apiservice.getLatestPurchasesCountForDashboard('4','1')
  }
  viewAll(){
    if(this.latestPurchaseData?.total_purchases > 0){
      this.router.navigate(['all-latest-purchase'])

    }
  }

  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"",
      title: 'Purchases'
    }})
    }

}
